<template>
	<div class="wrapper page-home" :class="currentPage">
		
		<transition-group mode="in-out" :name="transitionName" tag="div">
			<video-bg :sources="[sources[currentN]]" :img="sourcesImg[currentN]" id="video-bg" v-bind:class="{ creative: currentPage === 'creative' }" :key="currentN" v-if="show"></video-bg>
		</transition-group>

		<transition-group name="fade" mode="out-in">
			<player v-if="isPlaying && i18n.locale==='pl'" poster="../../assets/img/saatchi__movie_web_3.jpg" :source="[sourcesVideoPl[currentN]]" :key="2"/>
			<player v-if="isPlaying && i18n.locale==='en'" poster="../../assets/img/saatchi__movie_web_3.jpg" :source="[sourcesVideoEn[currentN]]" :key="1"/>

		</transition-group>

		<button class="play-button" v-if="!isPlaying" @click="isPlaying = true" v-bind:class="{ activeblue: currentPage === 'creative' }"></button>

		<footer class="footer">

			<div class="wrap-all-btn">
				<button 
				class="link arrow arrow-left" 
				@click="slide(-1), 
				changeCurrentPage('design')" 
				v-bind:class="{ active: currentPage === 'creative' }">

			</button>

			<div class="wrap-center" v-bind:class="{ creative: currentPage === 'creative' }">
				<button class="link slide slide-design" @click="slide(-1), changeCurrentPage('design')" v-bind:class="{ active: currentPage === 'design' }">design</button>
				<button  class="link slide slide-creative" @click="slide(1), changeCurrentPage('creative')" v-bind:class="{ active: currentPage === 'creative' }">creative</button>
			</div>

			<button class="link arrow arrow-right" @click="slide(1), changeCurrentPage('creative')" v-bind:class="{ active: currentPage === 'design' }"></button>
		</div>

		<a href="http://saatchiis.pl" class="company-name link" v-bind:class="{ blue: currentPage === 'creative' }" alt="" target="_blank">Saatchi&#38;saatchi is</a>
	</footer>

</div>
</template>

<script>
import { EventBus, i18n } from '../main.js';

export default {
	props: ['currentPage'],
	data: () => ({
		i18n,
		isPlaying: false,
		source: 0,
		sourceVideoPl: 0,
		sourceVideoEn: 0,
		current: 0,
		direction: 0,
		transitionName: "fade",
		show: false,
		sources: [
		'../../assets/video/background_3.mp4',
		'../../assets/video/loop_strona_glowna.mp4'
		],
		sourcesImg: [
		'../../assets/img/home-bg-2.jpg',
		'../../assets/img/home-bg-4.jpg'
		],
		sourcesVideoPl: [
		'../../assets/video/Saatchi_Saatch_IS_space_sub.mp4',
		'../../assets/video/SAATCHI_WATER_2_SUB_LIGHT_PL.mp4',
		],
		sourcesVideoEn: [
		'../../assets/video/Saatchi_Saatch_IS_space.mp4',
		'../../assets/video/Saatchi_woda.mp4',
		],
	}),
	methods: {
		slide(dir) {
			/*sliding*/
			this.direction = dir;
			if(dir === 1) {
				this.transitionName = "slide-next";
				this.current = 1;
			} else {
				this.transitionName = "slide-prev";
				this.current = 0;
			}
		},
		changeCurrentPage(page){
			if(page === 'design') {
				this.sourceVideoEn = 0;
				this.sourceVideoPl = 0;
			} else {
				this.sourceVideoEn = 1;
				this.sourceVideoPl = 1;
						// document.querySelector('.VideoBg').classList.add('creative');
					}
					
					EventBus.$emit('currentPage', page)
				}
			},
			created(){
				EventBus.$on('closePlayer', ()=>{
					this.isPlaying = false
				})
			},
			mounted() {
				this.show = true;
			},
			computed: {
				currentN() {
					if(this.currentPage === 'creative') {
						return  1;
					} else {
						return 0
					}
				}
			}

		// beforeRouteUpdate (home, contact, next) {
		//      if(this.currentPage === 'creative') {
		//         console.log('oeifwoiehnfuiowe4f');
		//         this.current = 1;
		//         console.log(this.currentPage);
		//     } else {this.current = 0}
		// },
		// watch: {
		//   '$router' (home, contact) {
		//      if(this.currentPage === 'creative') {
		//         console.log('oeifwoiehnfuiowe4f');
		//         this.current = 1;
		//         console.log(this.currentPage);
		//     } else {this.current = 0}
		//   }
		// }
	}
	</script>

	<style>
	/* Styles for slider*/
	body {
		overflow: hidden;
	}
	.fade-enter-active {
		transition: opacity 1s;
	}
	.fade-enter {
		opacity: 0;
	}
	.slide-next-enter-active,
	.slide-next-leave-active {
		transition: transform 0.4s ease-in-out;
	}
	.slide-next-enter {
		transform: translate(100%);
	}
	.slide-next-leave-to {
		transform: translate(-100%);
	}
	.slide-prev-enter-active,
	.slide-prev-leave-active {
		transition: transform 0.4s ease-in-out;
	}
	.slide-prev-enter {
		transform: translate(-100%);
	}
	.slide-prev-leave-to {
		transform: translate(100%);
	}
	/* Styles for BG*/
	.VideoBg {
		position: absolute !important;
	}

	.VideoBg__content{
		background: rgba(0,0,0,0.8);
		width: 100%;
	}
	.VideoBg.creative .VideoBg__content{
		background: rgba(0,0,0,0);
		/*width: 0 !important;*/
	}
	.VideoBg__content.creative{

	}

	/* Styles for button in the center*/
	.play-button{
		border: none;
		width: 88px;
		height: 88px;
		background: url(../../assets/img/play-button.png);
		background-size: cover;
		z-index: 9;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.play-button:focus {
		outline:0;
	}

	.play-button.activeblue{
		background-image: url(../../assets/img/play-button-blue.png);
	}


	/* Styles for footer*/
	.footer {
		position: fixed;
		bottom: 6.7%;
		text-transform: uppercase;
		text-align: center;
		width: 100%;
		padding: 0 13%;
		box-sizing: border-box;
	}
	.footer .link {
		display: block;
		text-decoration: none;
	}
	.footer .wrap-all-btn {
		display: -webkit-box; 
		display: flex;
		justify-content: space-between;
		-webkit-justify-content: space-between;
	}
	.footer .wrap-all-btn button {
		border: none;
		cursor: pointer;
	}
	.footer .wrap-all-btn button:focus {
		outline: none;
	}
	.footer .wrap-all-btn .arrow {
		width: 66px;
		height: 23px;
		margin-top: 20px;
		transition: all 0.3s;
	}
	.footer .wrap-all-btn .arrow.active:hover {
		transition: all 0.3s;
		transform: scale(1.1);
	}
	.footer .wrap-all-btn .arrow-left {
		background: url(../../assets/img/arrow_silver_left.png);
	}
	.footer .wrap-all-btn .arrow-left.active {
		background: url(../../assets/img/arrow_blue_left.png);
		transition: all 0.5s;
	}
	.footer .wrap-all-btn .arrow-right {
		background: url(../../assets/img/arrow_silver_right.png);
	}
	.footer .wrap-all-btn .arrow-right.active {
		background: url(../../assets/img/arrow_gold_right.png);
		transition: all 0.5s;
	}
	.footer .wrap-all-btn .wrap-center {
		position: relative;
		display: none;
	}
	.footer .wrap-all-btn .wrap-center:after {
		content: '';
		display: block;
		width: 13px;
		height: 13px;
		background: #998551;
		border-radius: 50%;
		position: absolute;
		bottom: 2px;
		right: 49%;
	}

	.footer .wrap-all-btn .wrap-center.creative:after {
		background: #96bbf6;
	}

	.footer .wrap-all-btn .slide {
		font-size: 12px;
		display: inline-block;
		width: 49%;
		color: #a2a2a2;
		position: relative;
		background: transparent;
		text-transform: uppercase;
	}
	.footer .wrap-all-btn .slide-design.active {
		color: #998551;
		transition: all 0.5s;
	}
	.footer .wrap-all-btn .slide-creative.active {
		color: #96bbf6;
		transition: all 0.5s;
	}
	.footer .wrap-all-btn .slide-design.active:before,
	.footer .wrap-all-btn .slide-design.active:after {
		background: #998551;
		transition: all 0.5s;
	}

	.footer .wrap-all-btn .slide-creative.active:before,
	.footer .wrap-all-btn .slide-creative.active:after  {
		background: #96bbf6;
		transition: all 0.5s;
	}

	.footer .wrap-all-btn .slide-design:before,
	.footer .wrap-all-btn .slide-creative:before{
		content: '';
		display: block;
		width: 100%;
		height: 2px;
		background: #a2a2a2;
		position: absolute;
		bottom: -17px;
		left: 0;
	}
	.footer .wrap-all-btn .slide-design:after {
		content: '';
		display: block;
		width: 13px;
		height: 13px;
		background: #a2a2a2;
		border-radius: 50%;
		position: absolute;
		bottom: -22px;
		left: 0;
	}
	.footer .wrap-all-btn .slide-creative:after {
		content: '';
		display: block;
		width: 13px;
		height: 13px;
		background: #a2a2a2;
		border-radius: 50%;
		position: absolute;
		bottom: -22px;
		right: 0;
	}

	.footer .company-name {
		color: #998551;
		font-size: 11px;
		letter-spacing: 6px;
		margin-top: 73px;
		transition: color 0.5s;
	}

	.footer .company-name.blue {
		color: #96bbf6;
	}

	@media(min-width: 560px) {
		.play-button{
			width: 115px;
			height: 115px;
		}
		.footer .wrap-all-btn .wrap-center {
			display: block;
			width: 51%;
		}
	}
	@media(min-width: 940px) {
		.footer .wrap-all-btn .slide {
			font-size: 14px;
		}
		.footer .wrap-all-btn .wrap-center {
			width: 35.9%;
		}
	}

	</style>



// WEBPACK FOOTER //
// src/components/home.vue